import type { INavListItem } from '@/api/types/public';

/**
 * 主导航下拉面板 submenu_item_GG_II 坑位编码的扁平序号工具。
 *
 * 编码约定（评审站截图证据）：GG = 一级菜单序号（01 起），II = 该下拉面板内
 * 三级可点击条目按组件渲染顺序的扁平序号（01 起）：先按顺序累加各文字分类
 * （TextNav）区块的条目，再累加图片分类（ImageNavigationNav）区块的条目。
 * 镜片流程（LensProcessNav）与资源位（ResourceSlotNav）没有条目编码。
 */

/** 扁平条目序号 → 坑位键 submenu_item_GG_II（GG/II 均两位，01 起）。 */
export function buildSubmenuSpmPosition(firstLevelIndex: number, flatItemIndex: number): string {
  return `submenu_item_${String(firstLevelIndex + 1).padStart(2, '0')}_${String(
    flatItemIndex + 1,
  ).padStart(2, '0')}`;
}

/** 各文字分类区块的扁平条目偏移（Map：区块 → 前置区块条目累计数）。 */
export function getTextNavSpmItemOffsets(items: INavListItem[]): Map<INavListItem, number> {
  const offsets = new Map<INavListItem, number>();
  let runningCount = 0;
  items.forEach((item) => {
    offsets.set(item, runningCount);
    runningCount += item.content?.list?.length || 0;
  });
  return offsets;
}

/** 各图片分类模块的扁平条目偏移（只统计带 jump_image 的可点击图片条目）。 */
export function getImageNavigationSpmItemOffsets(items: INavListItem[]): Map<INavListItem, number> {
  const offsets = new Map<INavListItem, number>();
  let runningCount = 0;
  items.forEach((item) => {
    offsets.set(item, runningCount);
    runningCount +=
      item.content?.list?.filter((listItem) => Boolean(listItem.jump_image)).length || 0;
  });
  return offsets;
}
